// extracted by mini-css-extract-plugin
export default {"chart":"Echarts_chart__Q-2Pc"};